<script>
  
  export default {
    components: {  },
    props: {
      pesquisasPreco: {
        required: true
      },
    },
    data() {
      return {
        salvandoAprovacao: false,
        animated: false,
      }
    },
    methods: {
      lista(pagina = 1) {
        this.pesquisasPreco.pagina = pagina;

        this.$emit('lista');
      },
    },
  }
</script>

<template>
  <div class="group">
    <h4 class="text-center">Sem pesquisas de preço para aprovação</h4>

    <div class="hr-line-dashed margin-top-5"></div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/aprovar-pesquisa-preco/componentes/compartilhado/AprovarPesquisaPrecoSemLista.vue